import React from 'react'
import { useState } from 'react'
import { useEffect } from 'react'
import { GetVideoList, GlobalUrl, VideoUpdate, VideoAdd, VideoDelete } from '../db/db'
import { Form, Col, Row, Button, Modal, ProgressBar } from "react-bootstrap";
import { FaNewspaper, FaTrashAlt, FaWpforms } from 'react-icons/fa';
import { useAlert } from "react-alert";
const MagazinProperties=(props)=> {
    const QIssueIDData = (window.location.search.split("?MID=")[1] != undefined) ? window.location.search.split("?MID=")[1] : window.location.pathname.split('/')[1]
    const [QIssueID, setQIssueID] = useState(QIssueIDData)
    const [videList,setVideoList]=useState([])
    const [visibEdit,setVisEdit]=useState("none")
    const [selectVideo,setDelectVide]=useState()
  const [videovar, setVidevar] = useState("block")
    const LoadVideoList=async()=>{
      const videList = await GetVideoList(QIssueID).then((res)=>{
        if(Array.from(res.sonuc).length>0)
        {setVidevar("none")}
            setVideoList(res.sonuc)})
    }
    useEffect(async()=>{
        LoadVideoList()
    },[])
  const myAlert = useAlert();
  return (
    <>
        <hr style={{color:'GrayText',size:"3"}}/>
        <div style={{textAlign:'center',fontWeight:"bold"}}>Dergi Gif Videosu </div>
        <hr style={{ color: 'GrayText', size: "3" }} />

      <Form.Control accept=".gif" type="file" placeholder="Güncelle" style={{ margin: 7, display: videovar }}
        onChange={
          (e) => {
            
            if(e.target.files[0].type !="image/gif"){
              e.target.value=""
              alert("Yalnızca gif dosyaları yüklenebilir.")
            }
            else
            setDelectVide(e.target.files[0])
          }}
      />

      <Button  className="btn-light" size="sm" active style={{ margin: 7, display: videovar }} onClick={async () => {
        const UpdateResult = await VideoAdd(selectVideo, 0, QIssueID, 0).then((result) => {

          LoadVideoList()
          myAlert.success("video Dosyası İşlendi")
          return result
        })
      }} > <FaNewspaper /> Yeni Ekle
      </Button>
        {
           //console.log("videos",videList)
             videList.map((data,index)=>{
                const imgData=GlobalUrl+"primemags/"+QIssueID+"/"+data.videoPath;
                return (
                  <div>
                <img id={index} src={imgData} style={{height:150,width:100}}/><br/>
                    <Form.Control accept=".gif" type="file" placeholder="Güncelle" style={{ margin: 7 }}
                      onChange={
                         (e) => {
                           setDelectVide(e.target.files[0])
                        }}
                    />
                    {/* <Button className="btn-light" size="sm" active style={{ margin: 7 }} onClick={async () => {
                      const UpdateResult = await VideoAdd(selectVideo, 0, QIssueID, 0).then((result) => {

                        LoadVideoList()
                        myAlert.success("video Dosyası İşlendi")
                        return result
                      })
                    }} > <FaNewspaper /> Yeni Ekle
                    </Button> */}
                    <Button className="btn-light" size="sm" active style={{ margin: 7 }} onClick={async()=>{
                          const UpdateResult=await VideoUpdate(selectVideo,0,QIssueID,data.id).then((result)=>{
                            myAlert.success("video Dosyası İşlendi")
                            LoadVideoList()
                            return result
                          })

                          console.log("other const",UpdateResult)
                    }} > <FaWpforms /> Güncelle
                    </Button>
                   
                    <Button className="btn-light" size="sm" active style={{ margin: 7 }} onClick={async ()=>{
                      const UpdateResult = await VideoDelete(data.id).then((result) => {
                        setVidevar("block")
                        LoadVideoList()
                        myAlert.success("video silme tamamlandı")
                        return result
                      })

                    }} > <FaTrashAlt /> Sil
                    </Button>
                </div>)
            }) 
        }
    </>
  )
}

export default MagazinProperties
